import {format} from "date-fns";

export default class {

    getUrlParams() {
        var params = {};

        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi,
            function (str, key, value) {
                params[key] = value;
            }
        );

        return params;
    }

    getCompatDate(date) {
        date = date.toString()
        return new Date(date.replace(/-/g, "/"))
    }

    getDateWithFormat(date, formatString = 'yyyy-MM-dd') {

        if (date == null || date.length == 0) {
            return ''
        }

        return format(this.getCompatDate(date), formatString)
    }
}

